var base = '_18m5zws6';
var bone = '_18m5zws7';
var boneRadius = {sm:'_18m5zws8',md:'_18m5zws9',lg:'_18m5zwsa',full:'_18m5zwsb'};
var reducedMotionPulse = '_18m5zws4';
var root = '_18m5zws5';
var shimmer = '_18m5zws3';
var shimmerDuration = 'var(--_18m5zws2)';
var shimmerEndPosition = 'var(--_18m5zws1)';
var shimmerStartPosition = 'var(--_18m5zws0)';
var text = '_18m5zwse';
var textBodySize = {sm:'_18m5zwsg',md:'_18m5zwsh',lg:'_18m5zwsi'};
var textHeadingSize = {sm:'_18m5zwsj',md:'_18m5zwsk',lg:'_18m5zwsl'};
var textSizing = '_18m5zwsf';

export { base, bone, boneRadius, reducedMotionPulse, root, shimmer, shimmerDuration, shimmerEndPosition, shimmerStartPosition, text, textBodySize, textHeadingSize, textSizing };
//# sourceMappingURL=skeleton.css.js.map
